// frontend/src/components/Network/SecureGate.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SecureGate.module.css';
import networkService from '../../services/networkService';
import { useI18n } from '../../i18n';

const SecureGate = ({ onUnlock, hasPin }) => {
  const { t } = useI18n();
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const Maps = useNavigate();

  const handleVerify = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const data = await networkService.getConnections(pin);
      onUnlock(pin, data);
    } catch (err) {
      if (err.message === 'PIN_INVALID') {
        setError(true);
        setPin('');
        // El shake se activa por la clase CSS
        setTimeout(() => setError(false), 500);
      }
    } finally {
      setLoading(false);
    }
  }, [pin, onUnlock]);

  useEffect(() => {
    if (pin.length === 4) {
      handleVerify();
    }
  }, [pin, handleVerify]);

  const addDigit = (digit) => {
    if (pin.length < 4) {
      setPin(prev => prev + digit);
    }
  };

  const removeDigit = () => {
    setPin(prev => prev.slice(0, -1));
  };

  if (!hasPin) {
    return (
      <div className={styles.overlay}>
        <div className={styles.gateContent}>
          <h2 className={styles.title}>{t('network.restricted')}</h2>
          <p className={styles.subtitle}>{t('network.configurePinHint')}</p>
          <button
            className={styles.configPinBtn}
            onClick={() => Maps('/ajustes#red-silenciosa')}
          >
            {t('network.configurePin')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={`${styles.gateContent} ${error ? styles.shake : ''}`}>
        <h2 className={styles.title}>{t('network.verification')}</h2>
        <p className={styles.subtitle}>{t('network.enterPin')}</p>

        <div className={styles.pinDisplay}>
          {[0, 1, 2, 3].map(i => (
            <div
              key={i}
              className={`${styles.dot} ${pin.length > i ? styles.dotFilled : ''}`}
            />
          ))}
        </div>

        <div className={styles.numpad}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
            <button
              key={num}
              className={styles.numBtn}
              onClick={() => addDigit(num.toString())}
              disabled={loading}
            >
              {num}
            </button>
          ))}
          <div /> {/* Espacio vacío */}
          <button
            className={styles.numBtn}
            onClick={() => addDigit('0')}
            disabled={loading}
          >
            0
          </button>
          <button
            className={`${styles.numBtn} ${styles.backspace}`}
            onClick={removeDigit}
            disabled={loading || pin.length === 0}
          >
            ←
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecureGate;
